/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/Tasks/Content/AssignedTo/Content",
  ignoreClickOutsideIf
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let taskValueData = fromData.useDataValue({ viewPath,
context: 'task',
})
let globalValueData = fromData.useDataValue({ viewPath,
context: 'global',
})
let aggregateData = fromHelpers.getAssigneeName(taskValueData, globalValueData)
let dtFontsizesMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'fontSizes.mm'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Horizontal}`}
>
<Popover
  viewPath={`${viewPath}/Popover`}
 ignoreClickOutsideIf={ignoreClickOutsideIf}
 placement="bottom"
 offsetMainAxis={4}
 offsetCrossAxis={-100}
 width={240}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="normal"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 fontSize={dtFontsizesMm}
 marginRight={dtSpaceXxs}
 color={dtColorsNeutral900}
 data="task"
 data="global"
 aggregate="./helpers.js getAssigneeName"
 text={aggregateData}
/>
<TysiaButtonIcon
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 width="10px"
 height="10px"
 fill2={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
</div>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
</div>
{children}
</React.Fragment>)
}